import request from '@/utils/request'
import { ConstConfig, AppType } from '@/utils'
import { getWXInfo, getToken } from '@/libs/cookie-storage'

export function login(userName, password) {
  const data = {
    username: userName,
    password: password,
    remember: 365
  }
  return request({
    url: ConstConfig.authApiPath + '/login.do',
    method: 'post',
    data: data
  })
}

export function smsLogin(userName, smsCode, extObj) {
  let data = {
    loginName: userName,
    sendCode: smsCode,
    loginType: 'mobile',
    action: 'fastBind',
    remember: 365
  }
  // if (AppType.isInWeChat()) {
  //   const wxInfo = getWXInfo()
  //   data.passport = wxInfo.openId
  //   data.link = true
  // }
  if (extObj && extObj.certNumber) {
    data.certificateType = extObj.certType
    data.certificateNum = extObj.certNumber
    data.trueName = extObj.realName
  }
  return request({
    url: ConstConfig.authApiPath + '/registerMobile.do',
    method: 'post',
    data: data
  })
}

export function sendSmsCode(userName) {
  const params = {
    mobile: userName,
    loginType: 'mobile',
    action: 'sendFastBindCode'
  }
  return request({
    url: ConstConfig.authApiPath + '/registerMobile.do',
    method: 'get',
    params
  })
}

export function getInfo() {
  return request({
    url: ConstConfig.apiPath + '/GetUserInfo.do',
    method: 'get'
  })
}

export function logout() {
}

export function checkSSO() {
  return request({
    url: ConstConfig.authApiPath + '/checkSSO.do',
    method: 'get'
  })
}

export function loginWechat(code) {
  const params = {
    code: code,
    disableAutoRegister: true
  }
  return request({
    url: ConstConfig.wxApiPath + '/LoginWechat.json',
    method: 'get',
    params
  })
}

export function getWeChatSignature(params) {
  return request({
    url: ConstConfig.wxApiPath + '/GetWechatSign.json',
    method: 'get',
    params
  })
}

export function bindWeChat() {
  if (!AppType.isInWeChat()) return
  const wxInfo = getWXInfo()
  if (!wxInfo) return
  const data = {
    accessToken: wxInfo.accessToken,
    openId: wxInfo.openId,
    passport: getToken(),
    link: true,
    clientId: ConstConfig.wxAppId,
    clientType: 'banma_mp'
  }
  return request({
    url: ConstConfig.authApiPath + '/loginWX.do',
    method: 'post',
    data: data
  })
}

export function loginQQ(code) {
  const params = {
    code: code,
    disableAutoRegister: true
  }
  return request({
    url: ConstConfig.wxApiPath + '/LoginQQ.json',
    method: 'get',
    params
  })
}

export function bindQQ() {
  if (!AppType.isInQQ()) return
  const wxInfo = getWXInfo()
  if (!wxInfo) return
  const data = {
    accessToken: wxInfo.accessToken,
    openId: wxInfo.openId,
    passport: getToken(),
    link: true,
    clientId: ConstConfig.wxAppId,
    clientType: 'banmaH5'
  }
  return request({
    url: ConstConfig.authApiPath + '/loginQQ.do',
    method: 'post',
    data: data
  })
}

/* qiniu token */
export function getQiniuUploadToken() {
  const params = {
    deadline: 3600,
    scope: 'snsports',
    strict: true
  }
  return request({
    url: ConstConfig.apiPath + '/GetQiniuUploadToken.json',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js